import { render, staticRenderFns } from "./EnergyRatingChart.vue?vue&type=template&id=45ad67e0"
import script from "./EnergyRatingChart.vue?vue&type=script&lang=ts"
export * from "./EnergyRatingChart.vue?vue&type=script&lang=ts"
import style0 from "./EnergyRatingChart.vue?vue&type=style&index=0&id=45ad67e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports